import { render, staticRenderFns } from "./LKPublicationsFormdataListModal.vue?vue&type=template&id=6a49c123&"
import script from "./LKPublicationsFormdataListModal.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsFormdataListModal.vue?vue&type=script&lang=js&"
import style0 from "./LKPublicationsFormdataListModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
